import {
    ApplicationAccessType,
    CommunicationType,
    WhatsAppButton,
    WhatsAppCarouselCard,
    WhatsAppHeaderComponent,
    WhatsAppFooterComponent,
    WhatsAppLTOComponent,
    WhatsAppTemplateType,
} from 'domains/content/types';

import { WhatsAppContentStateTypes } from './whatsAppTypes';

export enum actionTypes {
    SET_NAME = 'SET_NAME',
    SET_BODY_TEXT = 'SET_BODY_TEXT',
    SET_HEADER = 'SET_HEADER',
    SET_FOOTER = 'SET_FOOTER',
    SET_LANGUAGE = 'SET_LANGUAGE',
    SET_TEMPLATE_TYPE = 'SET_TEMPLATE_TYPE',
    ADD_BUTTON = 'ADD_BUTTON',
    UPDATE_BUTTON = 'UPDATE_BUTTON',
    REMOVE_BUTTON = 'REMOVE_BUTTON',
    REORDER_BUTTONS = 'REORDER_BUTTONS',
    ADD_CAROUSEL_CARD = 'ADD_CAROUSEL_CARD',
    UPDATE_CAROUSEL_CARD = 'UPDATE_CAROUSEL_CARD',
    REMOVE_CAROUSEL_CARD = 'REMOVE_CAROUSEL_CARD',
    SET_LTO = 'SET_LTO',
    SET_APPLICATIONS_ACCESS = 'SET_APPLICATIONS_ACCESS',
    SET_COMMUNICATION_TYPE = 'SET_COMMUNICATION_TYPE',
    SET_WHATSAPP_STATE = 'SET_WHATSAPP_STATE',
    SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE',
    ADD_LANGUAGE = 'ADD_LANGUAGE',
    DELETE_LANGUAGE = 'DELETE_LANGUAGE',
}

export const setName = (name: string) => ({ type: actionTypes.SET_NAME, name });

export const setBodyText = (text: string) => ({ type: actionTypes.SET_BODY_TEXT, text });

// Pass null to remove the header component entirely
export const setHeader = (header: WhatsAppHeaderComponent | null) => ({ type: actionTypes.SET_HEADER, header });

// Pass null to remove the footer component
export const setFooter = (footer: WhatsAppFooterComponent | null) => ({ type: actionTypes.SET_FOOTER, footer });

export const setLanguage = (language: string) => ({ type: actionTypes.SET_LANGUAGE, language });

export const setTemplateType = (templateType: WhatsAppTemplateType) => ({
    type: actionTypes.SET_TEMPLATE_TYPE,
    templateType,
});

export const addButton = (button: WhatsAppButton) => ({ type: actionTypes.ADD_BUTTON, button });

export const updateButton = (index: number, button: WhatsAppButton) => ({
    type: actionTypes.UPDATE_BUTTON,
    index,
    button,
});

export const removeButton = (index: number) => ({ type: actionTypes.REMOVE_BUTTON, index });

export const reorderButtons = (buttons: WhatsAppButton[]) => ({ type: actionTypes.REORDER_BUTTONS, buttons });

export const addCarouselCard = (card: WhatsAppCarouselCard) => ({ type: actionTypes.ADD_CAROUSEL_CARD, card });

export const updateCarouselCard = (index: number, card: WhatsAppCarouselCard) => ({
    type: actionTypes.UPDATE_CAROUSEL_CARD,
    index,
    card,
});

export const removeCarouselCard = (index: number) => ({ type: actionTypes.REMOVE_CAROUSEL_CARD, index });

export const setLTO = (lto: WhatsAppLTOComponent['limited_time_offer']) => ({ type: actionTypes.SET_LTO, lto });

export const setApplicationsAccess = (applicationsAccess: ApplicationAccessType[]) => ({
    type: actionTypes.SET_APPLICATIONS_ACCESS,
    applicationsAccess,
});

export const setCommunicationType = (communicationType: CommunicationType) => ({
    type: actionTypes.SET_COMMUNICATION_TYPE,
    communicationType,
});

export const setWhatsAppState = (whatsAppState: WhatsAppContentStateTypes) => ({
    type: actionTypes.SET_WHATSAPP_STATE,
    whatsAppState,
});

export const setSelectedLanguage = (language: string) => ({ type: actionTypes.SET_SELECTED_LANGUAGE, language });

export const addLanguage = (language: string) => ({ type: actionTypes.ADD_LANGUAGE, language });

export const deleteLanguage = (language: string) => ({ type: actionTypes.DELETE_LANGUAGE, language });
